import { render, staticRenderFns } from "./TitlesSectionsModal.vue?vue&type=template&id=3c0a4fac"
import script from "./TitlesSectionsModal.vue?vue&type=script&lang=js"
export * from "./TitlesSectionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports